import { css } from "styled-components";
import { breakpoints } from "../../theme/common";
export default css`
  .container {
    width: 100%;
    display: flex;
    align-self: center;
    margin: auto;
  }

  ${breakpoints.xs} {
    .container {
      padding: 20px;
    }
  }
  ${breakpoints.sm} {
    .container {
      max-width: 540px;
    }
    .arrow-back-container{
      max-width: 540px;
    }
  }
  ${breakpoints.md} {
    .container {
      max-width: 720px;
    }
    .arrow-back-container{
      max-width: 720px;
    }
  }
  ${breakpoints.lg} {
    .container {
      max-width: 960px;
    }
    .arrow-back-container{
      max-width: 960px;
    }
  }
  ${breakpoints.xl} {
    .container {
      max-width: 1140px;
    }
    .arrow-back-container{
      max-width: 1140px;
    }
  }
  ${breakpoints.xxl} {
    .container {
      max-width: 1320px;
    }
    .arrow-back-container{
      max-width: 1320px;
    }
  }
`
